/* Otishi Bundle Builder — vanilla JS state machine.
   Behavioral spec: design_handoff_bundle_builder (Bundle Builder.dc.html).
   All prices/savings derive from the section's schema settings via the
   embedded JSON config, so copy never drifts from the configured math.
   Free gear model: simple gifts auto-add (program at 1+, socks at 2+,
   straps at 3+ when configured); apparel gifts (tee, sweats, ...) unlock
   at 3+ and each need a color + size pick, or an explicit skip. */
(function () {
  'use strict';

  function init(root) {
    var cfgEl = root.querySelector('[data-bb-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.error('[bundle-builder] bad config', e); return; }

    var P1 = parseFloat(cfg.pricing.p1) || 84.99;
    var P2 = parseFloat(cfg.pricing.p2) || 80;
    var P3 = parseFloat(cfg.pricing.p3) || 75;
    var CMP = parseFloat(cfg.pricing.compareAt) || 99.99;
    var SHIP = parseFloat(cfg.pricing.shipValue) || 9.95;

    function gearVal(g) {
      if (!g) return 0;
      var o = parseFloat(g.valueOverride);
      if (!isNaN(o) && o > 0) return o;
      return (parseInt(g.valueCents, 10) || 0) / 100;
    }
    var gear = cfg.gear || {};
    /* Graceful stockout degradation: physical gifts that are fully
       unavailable drop out of the offer entirely — no dead picker cards,
       no promised-but-never-shipped stack lines, checkout never blocked. */
    if (gear.socks && !gear.socks.available) gear.socks = null;
    if (gear.straps && !gear.straps.available) gear.straps = null;
    var apparel = (gear.apparel || []).filter(Boolean).map(function (a) {
      a.colors = (a.colors || []).filter(function (c) {
        return c.sizes.some(function (s) { return s.available; });
      });
      return a;
    }).filter(function (a) { return a.available && a.colors.length; });
    var V = {
      program: gearVal(gear.program),
      socks: gearVal(gear.socks),
      straps: gearVal(gear.straps)
    };
    var apparelValues = apparel.map(gearVal);
    /* Total value of everything that unlocks at tier 3 */
    function kitValue() {
      return V.straps + apparelValues.reduce(function (a, b) { return a + b; }, 0);
    }

    var colorways = (cfg.colorways || []).map(function (c) {
      c.soldOut = !c.variants.some(function (v) { return v.available; });
      return c;
    });
    var byId = {};
    colorways.forEach(function (c) { byId[c.id] = c; });

    var state = {
      pairs: [],
      pendingId: null,
      apparel: apparel.map(function () { return { color: null, size: null, choice: 'ship' }; }),
      pdpId: null
    };
    var lastTier = 0;

    /* ---------- helpers ---------- */
    function money(v) { return '$' + (v % 1 ? v.toFixed(2) : String(v)); }
    function moneyRound(v) { return '$' + Math.round(v); }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
      });
    }
    function perPair(n) { return n >= 3 ? P3 : n === 2 ? P2 : P1; }
    function bundlePrice(n) { return n === 0 ? 0 : n === 1 ? P1 : n === 2 ? 2 * P2 : 3 * P3 + (n - 3) * P3; }
    function apparelNames() {
      return apparel.map(function (a) { return a.name; }).join(' + ');
    }
    function track(name, payload) {
      var data = Object.assign({ event: name }, payload || {});
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
      /* The storefront's own gtag snippet configures GA4; a bare event call
         reaches it. Do NOT use send_to — unregistered destinations are
         silently dropped (verified the hard way). */
      try {
        if (typeof window.gtag === 'function') window.gtag('event', name, payload || {});
      } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('otishi:' + name, { detail: data })); } catch (e) {}
    }

    function q(sel) { return root.querySelector(sel); }

    /* ---------- static subline ---------- */
    (function renderSubline() {
      var el = q('[data-bb-subline]');
      if (!el) return;
      var tpl = cfg.copy.sublineTemplate || '';
      var progName = gear.program ? gear.program.name : 'training program';
      var progHtml = esc(progName) + ' <s>' + money(V.program) + '</s> <strong>FREE</strong>';
      el.innerHTML = esc(tpl).replace('[program]', progHtml).replace('[ship]', money(SHIP));
    })();

    /* ---------- render ---------- */
    function render() {
      var pairs = state.pairs;
      var n = pairs.length;
      var pp = perPair(n);
      var priceNum = bundlePrice(n);
      var nextPrice = n >= 2 ? P3 : n === 1 ? P2 : P1;

      renderLadder(n);
      renderPairs(pairs, n, pp);
      renderPicker(pairs, n, nextPrice);
      renderUnlock(n);
      renderApparel(n);
      renderSummary(pairs, n, pp, priceNum);
      renderFooter(pairs, n, pp, priceNum);
      renderOverlay(n, nextPrice);

      var tier = Math.min(n, 3);
      if (tier > lastTier) track('bundle_tier_reached', { tier: tier, pairs: n });
      lastTier = Math.max(lastTier, tier);
    }

    function tierSave(t) {
      var v = CMP * t + V.program + SHIP;
      if (t >= 2) v += V.socks;
      if (t >= 3) v += kitValue();
      return v - bundlePrice(t);
    }

    function renderLadder(n) {
      var host = q('[data-bb-ladder]');
      var freeGear3 = V.socks + kitValue();
      var html = [1, 2, 3].map(function (t) {
        var isCur = t === 3 ? n >= 3 : n === t;
        var hero = t === 2;
        var reached = n >= t;
        var active = isCur || (t === 1 && n === 0);
        var cls = 'bb-tier' + (isCur ? ' is-current' : '') + (hero ? ' is-hero' : '') + (!(active || hero || reached) ? ' is-dim' : '');
        var label = t === 1 ? '1 pair' : t === 2 ? '2 pairs' : 'Rotation 3-pack';
        var bonus = t === 1 ? 'Save ' + moneyRound(tierSave(1))
          : t === 2 ? 'Save ' + moneyRound(tierSave(2)) + ' &middot; free socks'
          : 'Save ' + moneyRound(tierSave(3)) + ' &middot; ' + moneyRound(freeGear3) + ' free gear';
        return '<div class="' + cls + '">' +
          (hero ? '<div class="bb-tier-pill">Most popular</div>' : '') +
          '<div class="bb-tier-label">' + label + '</div>' +
          '<div class="bb-tier-price">' + moneyRound(t === 1 ? P1 : t === 2 ? P2 : P3) + '<span>/pair</span></div>' +
          '<div class="bb-tier-bonus">' + bonus + '</div>' +
          '</div>';
      }).join('');
      host.innerHTML = html;
    }

    function renderPairs(pairs, n, pp) {
      var host = q('[data-bb-pairs]');
      host.style.display = n ? '' : 'none';
      host.innerHTML = pairs.map(function (p, i) {
        var c = byId[p.id];
        var missing = !p.size;
        var opts = '<option value="" disabled' + (missing ? ' selected' : '') + '>Pick size</option>' +
          c.variants.map(function (v) {
            return '<option value="' + v.id + '"' + (String(p.size) === String(v.id) ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' +
              esc(v.available ? 'Size ' + v.label : 'Size ' + v.label + ' — sold out') + '</option>';
          }).join('');
        return '<div class="bb-pair">' +
          '<div class="bb-pair-thumb" style="background-image:url(' + esc(c.thumb) + ')"></div>' +
          '<div class="bb-pair-meta"><div class="bb-pair-slot">Pair ' + (i + 1) + '</div><div class="bb-pair-name">' + esc(c.name) + '</div></div>' +
          '<div class="bb-pair-right">' +
          '<select class="bb-size-select' + (missing ? ' is-missing' : '') + '" data-action="size" data-index="' + i + '" aria-label="Pair size">' + opts + '</select>' +
          '<span class="bb-pair-price">' + money(pp) + '</span>' +
          '<button class="bb-remove" data-action="remove" data-index="' + i + '" aria-label="Remove pair">&times;</button>' +
          '</div></div>';
      }).join('');
    }

    function renderPicker(pairs, n, nextPrice) {
      q('[data-bb-step-title]').textContent = n === 0 ? 'Pick your first pair' : 'Pick pair ' + (n + 1);


      var noteHost = q('[data-bb-next-note]');
      var note = n === 1 ? 'New price — adding a 2nd repriced every pair'
        : n >= 2 ? 'New price — every pair now ' + money(P3) : null;
      noteHost.innerHTML = note
        ? '<div class="bb-next-note"><span class="bb-dot"></span><span>' + esc(note) + '</span></div>' : '';

      var hot = n >= 1 ? ' is-hot' : '';
      q('[data-bb-grid]').innerHTML = colorways.map(function (c) {
        var count = pairs.filter(function (p) { return p.id === c.id; }).length;
        var badge = count ? (count > 1 ? '&times;' + count + ' in bundle' : 'In bundle') : null;
        var pending = state.pendingId === c.id;
        var footRow;
        if (pending) {
          footRow = '<div class="bb-cw-sizerow">' +
            '<select class="bb-size-select bb-cw-size" data-action="pending-size" data-id="' + c.id + '" aria-label="Pick size">' +
            '<option value="" disabled selected>Pick size</option>' +
            c.variants.map(function (v) {
              return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
                esc(v.available ? 'Size ' + v.label : 'Size ' + v.label + ' — sold out') + '</option>';
            }).join('') +
            '</select>' +
            '<button class="bb-remove" data-action="pending-cancel" aria-label="Cancel">&times;</button></div>';
        } else {
          footRow = '<div class="bb-cw-row">' +
            '<span class="bb-cw-price"><s>' + money(CMP) + '</s> <span class="bb-next-price' + hot + '">' + money(nextPrice) + '</span></span>' +
            (c.soldOut
              ? '<button class="bb-add-btn" disabled>Sold out</button>'
              : '<button class="bb-add-btn" data-action="add" data-id="' + c.id + '">Add</button>') +
            '</div>';
        }
        return '<div class="bb-cw' + (count ? ' in-bundle' : '') + (c.soldOut ? ' sold-out' : '') + (pending ? ' is-pending' : '') + '">' +
          '<button class="bb-cw-info" data-action="info" data-id="' + c.id + '" aria-label="More info">i</button>' +
          (badge ? '<div class="bb-cw-badge">' + badge + '</div>' : '') +
          '<div class="bb-cw-img" style="background-image:url(' + esc(c.img) + ')"></div>' +
          '<div class="bb-cw-foot"><div class="bb-cw-name">' + esc(c.name) + '</div>' +
          footRow +
          '</div></div>';
      }).join('');

      var maxed = q('[data-bb-maxed]');
      maxed.style.display = n >= 3 ? '' : 'none';
      maxed.textContent = 'Full kit unlocked — every pair from here stays at ' + money(P3) + '.';
    }

    function renderUnlock(n) {
      var host = q('[data-bb-unlock]');
      if (n !== 1 && n !== 2) { host.innerHTML = ''; return; }
      var chips = [];
      if (n === 1 && gear.socks) chips.push({ g: gear.socks, v: V.socks, tag: 'FREE at 2' });
      if (gear.straps) chips.push({ g: gear.straps, v: V.straps, tag: 'FREE at 3' });
      apparel.forEach(function (a, i) {
        chips.push({ g: a, v: apparelValues[i], tag: 'FREE at 3' });
      });
      var fomoVal = (n === 1 ? V.socks : 0) + kitValue();
      var kitNames = apparel.map(function (a) { return a.name; });
      if (gear.straps) kitNames.push(gear.straps.name);
      if (!chips.length) { host.innerHTML = ''; return; }
      var eyebrow = n === 1 ? (gear.socks ? 'Unlock · Free crew socks' : 'Unlock · Free gear') : 'Unlock · The full kit';
      var title = n === 1
        ? (gear.socks ? 'Add a 2nd pair, get a free 3-pack of crew socks' : 'Add more pairs, unlock free gear')
        : 'One more pair unlocks the full kit';
      var body = n === 1
        ? 'Price drops to ' + money(P2) + '/pair. Mix and match any in-stock colorway.'
        : kitNames.length
          ? kitNames.join(' + ') + ', free. ' + money(P3) + '/pair.'
          : 'Every pair drops to ' + money(P3) + '.';
      var fomo = n === 1
        ? 'Stop at 1 and you leave ' + money(Math.round(fomoVal * 100) / 100) + ' of free gear behind.'
        : 'Walk away now and ' + money(Math.round(fomoVal * 100) / 100) + ' of free gear stays on the shelf.';
      host.innerHTML = '<div class="bb-unlock">' +
        '<div class="bb-unlock-head"><span class="bb-dot"></span><span class="bb-unlock-eyebrow">' + esc(eyebrow) + '</span></div>' +
        '<div class="bb-unlock-title">' + esc(title) + '</div>' +
        '<p class="bb-unlock-body">' + esc(body) + '</p>' +
        '<div class="bb-gear-row">' + chips.map(function (ch) {
          return '<div class="bb-gear-chip"><div class="bb-gear-img" style="background-image:url(' + esc(ch.g.img) + ')"></div>' +
            '<div><div class="bb-gear-name">' + esc(ch.g.name) + '</div>' +
            '<div class="bb-gear-tag"><s>' + money(ch.v) + '</s> <span>' + esc(ch.tag) + '</span></div></div></div>';
        }).join('') + '</div>' +
        (fomoVal > 0 ? '<p class="bb-fomo">' + esc(fomo) + '</p>' : '') +
        (cfg.flags.showSocialProof && n === 1 && cfg.copy.socialProof
          ? '<p class="bb-social">' + esc(cfg.copy.socialProof) + '</p>' : '') +
        '</div>';
    }

    function renderApparel(n) {
      var host = q('[data-bb-tee]');
      if (n < 3 || !apparel.length) { host.innerHTML = ''; return; }
      host.innerHTML = apparel.map(function (a, slot) {
        var st = state.apparel[slot];
        var colorSel = null;
        a.colors.forEach(function (c) { if (c.name === st.color) colorSel = c; });
        var noColor = !st.color;

        var colorsHtml = a.colors.map(function (c) {
          var sel = c.name === st.color;
          return '<button class="bb-tee-color' + (sel ? ' is-selected' : '') + '" data-action="apparel-color" data-slot="' + slot + '" data-color="' + esc(c.name) + '">' +
            '<div class="bb-tee-color-img" style="background-image:url(' + esc(c.img) + ')"></div>' +
            '<span class="bb-tee-color-name">' + esc(c.name) + '</span></button>';
        }).join('');

        var sizeSource = colorSel ? colorSel.sizes : (a.colors[0] ? a.colors[0].sizes : []);
        var sizesHtml = sizeSource.map(function (s) {
          var out = colorSel ? !s.available : true;
          var sel = colorSel && st.size === s.label;
          var cls = 'bb-tee-size' + (sel ? ' is-selected' : '') + (noColor ? ' no-color' : out ? ' is-out' : '');
          var title = noColor ? 'Pick a color first' : (out ? esc(st.color) + ' sold out in ' + esc(s.label) : '');
          return '<button class="' + cls + '" data-action="apparel-size" data-slot="' + slot + '" data-size="' + esc(s.label) + '"' +
            ((noColor || out) ? ' disabled' : '') + (title ? ' title="' + title + '"' : '') + '>' + esc(s.label) + '</button>';
        }).join('');

        var eyebrow = slot === 0 ? 'Last step' : 'Also free';
        var infoBtn = a.sizing
          ? ' <button class="bb-tee-info" data-action="apparel-info" data-slot="' + slot + '" aria-label="Sizing info" aria-expanded="' + (st.infoOpen ? 'true' : 'false') + '">i</button>'
          : '';
        var infoNote = a.sizing && st.infoOpen
          ? '<div class="bb-sizing-note">' + esc(a.sizing) + '</div>'
          : '';
        return '<div class="bb-card"' + (slot > 0 ? ' style="margin-top:28px"' : '') + '>' +
          '<div class="bb-card-head"><span class="bb-step">' + eyebrow + '</span><span class="bb-card-title">Your free ' + esc(a.name) + '</span></div>' +
          '<div class="bb-tee-zone">' +
          '<div class="bb-tee-colors">' + colorsHtml + '</div>' +
          '<div class="bb-tee-sizes-wrap">' +
          '<div class="bb-tee-size-label">Size' + (noColor ? '<em> — pick a color first</em>' : '') + infoBtn + '</div>' +
          '<div class="bb-tee-sizes">' + sizesHtml + '</div>' + infoNote +
          '</div></div>' +
          '<div class="bb-tee-skip-row"><button class="bb-tee-skip' + (st.choice === 'skip' ? ' is-active' : '') + '" data-action="apparel-skip" data-slot="' + slot + '">Don\'t want it? Skip this</button></div>' +
          '</div>';
      }).join('');
    }

    function renderSummary(pairs, n, pp, priceNum) {
      q('[data-bb-empty]').style.display = n ? 'none' : '';

      var chip = q('[data-bb-tier-chip]');
      var chipText = n === 2 ? 'Most popular' : n >= 3 ? 'Full kit' : null;
      chip.style.display = chipText ? '' : 'none';
      chip.textContent = chipText || '';

      var lines = pairs.map(function (p, i) {
        var c = byId[p.id];
        var sizeLabel = null;
        if (p.size) {
          c.variants.forEach(function (v) { if (String(v.id) === String(p.size)) sizeLabel = v.label; });
        }
        return line('Otishi 2.0 — ' + c.name, sizeLabel ? 'size ' + sizeLabel : 'pick a size', money(CMP), money(pp), false, i);
      });
      if (n >= 1) {
        if (gear.program) lines.push(line(gear.program.name, 'digital', money(V.program), 'FREE', true));
        lines.push(line('US shipping', null, money(SHIP), 'FREE', true));
      }
      if (n >= 2 && gear.socks) lines.push(line(gear.socks.name, null, money(V.socks), 'FREE', true));
      if (n >= 3) {
        if (gear.straps) lines.push(line(gear.straps.name, null, money(V.straps), 'FREE', true));
        apparel.forEach(function (a, i) {
          var st = state.apparel[i];
          if (st.choice === 'skip') return;
          var sub = st.color && st.size ? st.color + ' · ' + st.size : 'pick below';
          lines.push(line(a.name, sub, money(apparelValues[i]), 'FREE', true));
        });
      }
      q('[data-bb-stack]').innerHTML = lines.join('');

      var lockedHost = q('[data-bb-locked]');
      var locked = [];
      if (n === 1 && gear.socks) locked.push({ name: gear.socks.name + ' — ' + money(V.socks), hint: '1 pair away' });
      if (n >= 1 && n <= 2) {
        var away = n === 1 ? '2 pairs away' : '1 pair away';
        if (gear.straps) locked.push({ name: gear.straps.name + ' — ' + money(V.straps), hint: away });
        apparel.forEach(function (a, i) {
          locked.push({ name: a.name + ' — ' + money(apparelValues[i]), hint: away });
        });
      }
      if (locked.length) {
        var lockedTotal = (n === 1 ? V.socks : 0) + kitValue();
        lockedHost.innerHTML = '<div class="bb-locked-box">' +
          '<div class="bb-locked-head">Still locked — ' + money(Math.round(lockedTotal * 100) / 100) + ' in free gear</div>' +
          locked.map(function (l) {
            return '<div class="bb-locked-line"><span class="bb-locked-name">' + esc(l.name) + '</span><span class="bb-locked-hint">' + esc(l.hint) + '</span></div>';
          }).join('') + '</div>';
      } else lockedHost.innerHTML = '';

      var totalsHost = q('[data-bb-totals]');
      if (!n) { totalsHost.innerHTML = ''; return; }
      var tv = totalValue(n);
      totalsHost.innerHTML = '<div class="bb-totals">' +
        '<div class="bb-totals-row"><span class="bb-totals-label">Total value</span><s class="bb-totals-value-s">' + moneyRound(tv) + '</s></div>' +
        '<div class="bb-totals-row"><span class="bb-totals-label hi">Your price</span><span class="bb-totals-price">' + money(priceNum) + '</span></div>' +
        '<div class="bb-save-pill">' + saveLabel(n, tv, priceNum) + '</div></div>';
    }

    function line(name, sub, value, priceTxt, isFree, removeIndex) {
      return '<div class="bb-stack-line">' +
        '<span class="bb-stack-name">' + esc(name) + (sub ? ' <span class="bb-stack-sub">' + esc(sub) + '</span>' : '') + '</span>' +
        '<span class="bb-stack-right"><span class="bb-stack-price"><s>' + esc(value) + '</s> <span class="' + (isFree ? 'bb-price-free' : 'bb-price-val') + '">' + esc(priceTxt) + '</span></span>' +
        (removeIndex != null ? '<button class="bb-stack-x" data-action="remove" data-index="' + removeIndex + '" aria-label="Remove pair">&times;</button>' : '') +
        '</span></div>';
    }

    function totalValue(n) {
      var v = CMP * n + (n ? V.program + SHIP : 0);
      if (n >= 2) v += V.socks;
      if (n >= 3) {
        v += V.straps;
        apparel.forEach(function (a, i) {
          if (state.apparel[i].choice !== 'skip') v += apparelValues[i];
        });
      }
      return v;
    }

    function saveLabel(n, tv, priceNum) {
      var save = moneyRound(tv - priceNum);
      var pct = Math.round((1 - perPair(n) / CMP) * 100);
      return n === 1 ? 'You save ' + save + ' (' + pct + '% off shoes)' : 'You save ' + save;
    }

    function apparelIncomplete() {
      if (state.pairs.length < 3) return false;
      return apparel.some(function (a, i) {
        var st = state.apparel[i];
        return st.choice !== 'skip' && !(st.color && st.size);
      });
    }

    function renderFooter(pairs, n, pp, priceNum) {
      var host = q('[data-bb-footer]');
      if (cfg.flags.stickyBar === false) { host.style.display = 'none'; host.innerHTML = ''; return; }
      host.style.display = n ? '' : 'none';
      if (!n) { host.innerHTML = ''; return; }
      var needSizes = pairs.some(function (p) { return !p.size; });
      var needApparel = apparelIncomplete();
      var ready = !needSizes && !needApparel;
      var tv = totalValue(n);
      var meta = n === 1 ? '1 pair' : n + ' pairs · ' + money(pp) + '/pair';
      var kit = kitValue();
      var nudge = n === 1 && gear.socks ? '1 more pair unlocks free socks · ' + money(P2) + '/pair'
        : n === 2 && kit > 0 ? '1 more pair unlocks the full kit (' + money(Math.round(kit * 100) / 100) + ' free) · ' + money(P3) + '/pair'
        : n <= 2 ? '1 more pair drops every pair to ' + money(n === 1 ? P2 : P3) : null;
      host.innerHTML = '<div class="bb-footer-inner">' +
        '<div class="bb-footer-left">' +
        '<div class="bb-footer-price-row"><span class="bb-footer-price">' + money(priceNum) + '</span><s class="bb-footer-value">' + moneyRound(tv) + '</s></div>' +
        '<div class="bb-footer-save">' + saveLabel(n, tv, priceNum) + ' · ' + esc(meta) + '</div>' +
        (nudge ? '<div class="bb-footer-nudge"><span class="bb-dot"></span>' + esc(nudge) + '</div>' : '') +
        '</div>' +
        (ready
          ? '<div style="flex:0 0 auto"><button class="bb-cta" data-action="checkout">Checkout · ' + money(priceNum) + '</button></div>'
          : '<div class="bb-cta-blocked-wrap"><div class="bb-cta-blocked">Checkout · ' + money(priceNum) + '</div>' +
            '<div class="bb-cta-reason">' + (needSizes ? 'Pick a size for each pair to check out' : 'Pick your free gear sizes — or skip them') + '</div></div>') +
        '</div>';
    }

    function renderOverlay(n, nextPrice) {
      var host = q('[data-bb-overlay]');
      var c = state.pdpId != null ? byId[state.pdpId] : null;
      if (!c) { host.innerHTML = ''; return; }
      var hot = n >= 1 ? ' is-hot' : '';
      var reviews = c.reviews ? '<div class="bb-pdp-stars"><span class="stars">★★★★★</span><span class="count">' + esc(c.reviews) + ' reviews</span></div>' : '';
      host.innerHTML = '<div class="bb-overlay" data-action="close-pdp">' +
        '<div class="bb-pdp" data-stop-click>' +
        '<button class="bb-pdp-close" data-action="close-pdp" aria-label="Close">&times;</button>' +
        '<div class="bb-pdp-img" style="background-image:url(' + esc(c.img) + ')"></div>' +
        '<div class="bb-pdp-body">' +
        '<div class="bb-pdp-eyebrow">The Otishi 2.0</div>' +
        '<div class="bb-pdp-name">' + esc(c.name) + '</div>' + reviews +
        '<p class="bb-pdp-desc">' + esc(c.desc) + '</p>' +
        (c.sizing ? '<div class="bb-pdp-sizing">' + esc(c.sizing) + '</div>' : '') +
        '<div class="bb-pdp-price"><s>' + money(CMP) + '</s> <span class="bb-next-price' + hot + '">' + money(nextPrice) + '</span> in your bundle</div>' +
        (c.soldOut
          ? '<div class="bb-pdp-soldout">Sold out — back soon</div>'
          : '<button class="bb-cta" data-action="add" data-id="' + c.id + '">Add this pair</button>') +
        '</div></div></div>';
    }

    /* ---------- actions ---------- */
    function openSizePrompt(id) {
      var c = byId[id];
      if (!c || c.soldOut) return;
      state.pendingId = id;
      state.pdpId = null;
      render();
      var sel = q('.bb-cw-size');
      if (sel) {
        sel.closest('.bb-cw').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        sel.focus();
      }
    }

    function addPair(id, sizeId) {
      var c = byId[id];
      if (!c || c.soldOut) return;
      state.pairs.push({ id: id, size: sizeId || null });
      state.pendingId = null;
      state.pdpId = null;
      track('bundle_pair_added', { colorway: c.handle, pairs: state.pairs.length });
      render();
    }
    function removePair(i) {
      var c = byId[state.pairs[i].id];
      state.pairs.splice(i, 1);
      if (state.pairs.length < 3) {
        state.apparel = apparel.map(function () { return { color: null, size: null, choice: 'ship' }; });
      }
      track('bundle_pair_removed', { colorway: c ? c.handle : null, pairs: state.pairs.length });
      render();
    }

    function checkout() {
      track('bundle_checkout_click', { pairs: state.pairs.length, total: bundlePrice(state.pairs.length) });
      if (!cfg.flags.enableCheckout) {
        alert('Checkout is not wired up on this preview yet — the bundle pricing app ships next.');
        return;
      }
      var bid = 'bb-' + Date.now().toString(36);
      var n = state.pairs.length;
      var items = [];
      var counts = {};
      state.pairs.forEach(function (p) { counts[p.size] = (counts[p.size] || 0) + 1; });
      Object.keys(counts).forEach(function (vid) {
        items.push({ id: parseInt(vid, 10), quantity: counts[vid], properties: { _otishi_bundle: bid, _bundle_pairs: String(n) } });
      });
      var giftProps = { _otishi_bundle: bid, _bundle_pairs: String(n), _bundle_gift: 'Yes' };
      if (gear.program && gear.program.available) items.push({ id: gear.program.variantId, quantity: 1, properties: giftProps });
      if (n >= 2 && gear.socks && gear.socks.available) items.push({ id: gear.socks.variantId, quantity: 1, properties: giftProps });
      if (n >= 3 && gear.straps && gear.straps.available) items.push({ id: gear.straps.variantId, quantity: 1, properties: giftProps });
      if (n >= 3) {
        apparel.forEach(function (a, i) {
          var st = state.apparel[i];
          if (st.choice === 'skip' || !st.color || !st.size) return;
          var vid = null;
          a.colors.forEach(function (c) {
            if (c.name === st.color) c.sizes.forEach(function (s) { if (s.label === st.size && s.available) vid = s.id; });
          });
          if (vid) items.push({ id: vid, quantity: 1, properties: giftProps });
        });
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart add failed ' + r.status);
        window.location.href = '/checkout';
      }).catch(function (e) {
        console.error('[bundle-builder]', e);
        alert('Something went wrong adding your bundle — please try again.');
      });
    }

    root.addEventListener('click', function (ev) {
      var el = ev.target.closest('[data-action]');
      if (!el || !root.contains(el)) return;
      switch (el.dataset.action) {
        case 'add': openSizePrompt(parseInt(el.dataset.id, 10)); break;
        case 'pending-cancel': state.pendingId = null; render(); break;
        case 'remove': removePair(parseInt(el.dataset.index, 10)); break;
        case 'info': ev.stopPropagation(); state.pdpId = parseInt(el.dataset.id, 10); render(); break;
        case 'close-pdp':
          if (ev.target.closest('[data-stop-click]') && !ev.target.closest('.bb-pdp-close')) return;
          state.pdpId = null; render(); break;
        case 'apparel-color': {
          var slot = parseInt(el.dataset.slot, 10);
          var st = state.apparel[slot];
          var color = el.dataset.color;
          st.color = color;
          if (st.size) {
            var stillOk = false;
            apparel[slot].colors.forEach(function (c) {
              if (c.name === color) c.sizes.forEach(function (s) { if (s.label === st.size && s.available) stillOk = true; });
            });
            if (!stillOk) st.size = null;
          }
          render(); break;
        }
        case 'apparel-size': {
          if (el.disabled) break;
          state.apparel[parseInt(el.dataset.slot, 10)].size = el.dataset.size;
          render(); break;
        }
        case 'apparel-info': {
          var iSt = state.apparel[parseInt(el.dataset.slot, 10)];
          iSt.infoOpen = !iSt.infoOpen;
          render(); break;
        }
        case 'apparel-skip': {
          var sSlot = parseInt(el.dataset.slot, 10);
          var sSt = state.apparel[sSlot];
          sSt.choice = sSt.choice === 'skip' ? 'ship' : 'skip';
          if (sSt.choice === 'skip') track('bundle_gift_skipped', { item: apparel[sSlot].name, pairs: state.pairs.length });
          render(); break;
        }
        case 'checkout': checkout(); break;
      }
    });

    root.addEventListener('change', function (ev) {
      var pendingSel = ev.target.closest('[data-action="pending-size"]');
      if (pendingSel && pendingSel.value) {
        addPair(parseInt(pendingSel.dataset.id, 10), pendingSel.value);
        return;
      }
      var el = ev.target.closest('[data-action="size"]');
      if (!el) return;
      var i = parseInt(el.dataset.index, 10);
      if (state.pairs[i]) { state.pairs[i].size = el.value; render(); }
    });

    /* ---------- embedded-context guard ----------
       The checkout bar is position:fixed; when this section is used inside a
       longer page (homepage etc.), hide the bar while the section is off-screen
       so it doesn't follow visitors through unrelated content. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var f = q('[data-bb-footer]');
        if (f) f.classList.toggle('bb-offscreen', !entries[0].isIntersecting);
      }, { rootMargin: '120px 0px' });
      io.observe(root);
    }

    /* ---------- deep-link entry (?bb-add=<handle>) ---------- */
    try {
      var want = new URLSearchParams(window.location.search).get('bb-add');
      if (want) {
        colorways.forEach(function (c) {
          if (c.handle === want && !c.soldOut && state.pairs.length === 0) state.pairs.push({ id: c.id, size: null });
        });
      }
    } catch (e) {}

    render();
  }

  function boot() {
    document.querySelectorAll('[data-bundle-builder]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
